export const visitFlyout = 'visit';

export const rowsPerPageOptions = [
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

export const statusFilterOptions = [
  { label: 'All', value: 'ALL' },
  { label: 'Agency Error', value: 'Agency Error' },
  { label: 'Delivery Cancelled Duplicate', value: 'DeliveryCancelledDuplicate' },
  { label: 'Dispatched', value: 'Dispatched' },
  { label: 'Payer Processed', value: 'Payer Processed' },
  { label: 'Payer Validation Error', value: 'Payer Validation Error' },
  { label: 'Persist Payload Error', value: 'Persist Payload Error' },
  { label: 'Queued To Send', value: 'Queued To Send' },
  { label: 'Received', value: 'Received' },
  { label: 'Retry', value: 'Retry' },
  { label: 'Sent', value: 'Sent' },
  { label: 'Validation Error', value: 'Validation Error' },
];

export const text = {
  visitFilterBar: {
    apply: 'Apply',
    reset: 'Reset',
  },
  noDataMessage: 'No data to display. Change filters to return results.',
};
